export const itemDetailRouts = {
  ItemDetails: {
    screens: {
      ItemDetailsPage: 'item-details-page',
      SubstituteItemDetailPage: 'substitute-item-detail-page',
      ReplacementItemDetailsPage: 'replacement-item-detail-page',
      ItemReplacement: 'item-replacement',
      ItemScanner: 'item-scanner',
      ItemUpdate: 'item-update',
      CustomItem: 'custom-item',
    },
  },
};
